<template>
    <div class="wrapper">
        <input 
            :id="`range-${index}`"
            v-model="sliderValue" 
            class="range-slider" 
            :class="touchStart ? 'touch-active' : ''"
            :style="`--slider-percentage: ${sliderPercentage}`"
            type="range" 
            :min="min" 
            :max="max" 
            @input="handleInput">
        <div class="ranges">
            <span>0</span>
            <span>10</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'WeedSlider',
    props: {
        min: {
            type: Number,
            default: 0
        },
        max: {
            type: Number,
            default: 10
        },
        value: {
            type: Number,
            default: 0
        },
        index: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            sliderValue: this.value || 0,
            touchStart: false
        }
    },
    methods: {
        handleTouchStart(event) {
            this.touchStart = true
        },
        handleTouchEnd(event) {
            this.touchStart = false
            this.$emit('inputEnded', this.index)
        },
        handleInput(input) {
            const rangeValue = input.srcElement.value;
            this.$emit('input', rangeValue)
        }
    },
    computed: {
        sliderPercentage: function() {
            return `${(this.sliderValue / this.max) * 100}%`
        }
    },
    mounted() {
        document.getElementById(`range-${this.index}`).addEventListener('touchstart', this.handleTouchStart)
        document.getElementById(`range-${this.index}`).addEventListener('touchend', this.handleTouchEnd)
    }
}
</script>

<style lang="scss" scoped>
@import '@/assets/variables.scss';

$slider-width: 94%;

.wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    margin-top: 20px;

    .range-slider {
        position: relative;
        -webkit-appearance: none;
        width: $slider-width;
        height: 6px;
        background-color: $background-color;
        border-radius: 2px;

        &:before {
            content: "";
            position: absolute;
            inset-block: 0;
            width: var(--slider-percentage);
            background-color: $weed-green;
            border-radius: 2px;
        }

        &.touch-active::-webkit-slider-thumb {
            transform: scale(4) translate(-10%, -10%);
        }
    }

    .range-slider::-webkit-slider-thumb {
        -webkit-appearance: none;
        appearance: none;
        width: 10px;
        height: 10px;
        background-image: url('../../public/img/weed-leaf-2.png');
        background-size: contain;
        background-position: center center;
        background-repeat: no-repeat;
        transform: scale(3) translate(-10%, -10%);
        transition: .2s ease;
        cursor: pointer;
    }

    .ranges {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: $slider-width;

        span {
            font-weight: 500;
            font-size: 17px;
            margin-top: 8px;
            color: $weed-green;
        }
    }
}

</style>